import { Injectable } from '@angular/core';

@Injectable()
export class User {
    AESSignedDate?: string;
    AESSignedFromIP?: string;
    AllowDropShipmentInstructions?: boolean;
    AllowMobileApp?: boolean;
    AllowPrintDialog?: boolean;
    AllowViewInvoices?: boolean;
    AlwaysNotifyCustomRecipient?: boolean;
    AlwaysNotifyRecipient?: boolean;
    AlwaysNotifySender?: boolean;
    AlwaysPrintHighValue?: boolean;
    AlwaysPrintHighValueAfterLabel?: boolean;
    AlwaysPrintReceipt?: boolean;
    AlwaysPrintReceiptAfterLabel?: boolean;
    AlwaysSendCustomEmailToRecipient?: boolean;
    AlwaysSendEmailToRecipient?: boolean;
    AlwaysSendEmailToSender?: boolean;
    AlwaysUseThermal?: boolean;
    AnetProfileID?: string;
    APIAllowReturnLabels?: boolean;
    APIBackgroundColor?: string;
    APIConfirmationMessage?: string;
    APIDevStatus?: number;
    APIDisplayCaptcha?: boolean;
    APIDomain?: string;
    APIFont?: string;
    APIFontSize?: number;
    APIForeColor?: string;
    APIIsSchedulePickup?: boolean;
    APIKey?: string;
    APILabelDeliveryMethod?: number;
    APIResidentialOrBusiness?: number;
    APIShippingOptions?: boolean;
    AutomaticPayment?: boolean;
    AutomaticPrint?: boolean;
    BIRCounter?: number;
    ByPassRerouting?: boolean;
    BypassRerouting?: boolean;
    CountryCode?: string;
    CurrentPoints?: number;

    // Only used for saving. When reading, use AlwaysSendCustomEmailToRecipient.
    CustomEmailNotification?: boolean;

    CustomerId?: string;
    DefaultLocation?: string;
    DefaultShipToCountry?: string;
    DefaultUpsAccount?: string;
    Email?: string;
    EmailConfirmedOn?: string;
    FaxNum?: string;
    FirstName?: string;
    GuestContactID?: string;
    HideOptionalServices?: boolean;
    InsuredValueMultiplier?: number;
    InsuredValueMultiplierEnabled?: boolean;
    InsuredValueThreshold?: number;
    IsAdmin?: boolean;
    IsAPIUser?: boolean;
    IsAutoPrint?: boolean;
    IsCanadian?: boolean;
    IsConfirmedEmail?: boolean;
    IsCustomBillTo: boolean;
    IsCustomCountryList?: boolean;
    IsDowntownUser?: boolean;
    IsEuropean?: boolean;
    IsFedexDomestic?: boolean;
    IsFedExDomestic?: boolean;
    IsFedexInternational?: boolean;
    IsFedExInternational?: boolean;
    IsFirstLogon?: boolean;
    IsGuest?: boolean;
    IsGuestAddressBook?: boolean;
    IsGuestShipFrom?: boolean;
    IsGuestShipFromLayOut?: boolean;
    IsGuestShipFromLayout?: boolean;
    IsPPIDesktopUser?: boolean;
    IsPPS?: boolean;
    IsPPSMaster?: boolean;
    IsServiceSuspended?: boolean;
    IsUPSDomestic?: boolean;
    IsUPSInternational?: boolean;
    IsUSPSDomestic?: boolean;
    IsUSPSInternational?: boolean;
    LastName?: string;
    LastTrackingDate?: string;
    MasterCustomerId?: string;
    MobileSessionID?: string;
    MobileTermsAcceptedFrom?: string;
    MobileTermsAcceptedOn?: string;
    Password?: string;
    PendingPoints?: number;
    SessionID?: string;
    ShowAESAgreement?: boolean;
    ShowDropShipments?: boolean;
    ShowEmailTemplates?: boolean;
    ShowLoginNotice?: boolean;
    ShowNoDriverRelease?: boolean;
    ShowRates?: boolean;
    SkipHVQueue?: boolean;
    Status?: number;
    SubmitDate?: string;
    TelExt?: string;
    TelNum?: string;
    TermsAcceptedFromIP?: string;
    TermsAcceptedOn?: string;
    UserId?: number;
    UserName?: string;
    WeightUOM?: string;
    DefaultUploadTabIndex?: number;
}
